module.exports = __webpack_public_path__ + "static/media/location-pin.0e6a283b.svg";